(function(){
  function flash(el){
    el.classList.add('copied');
    clearTimeout(el._copyTimer);
    el._copyTimer = setTimeout(function(){ el.classList.remove('copied'); }, 1600);
  }
  document.addEventListener('click', function(e){
    var el = e.target.closest ? e.target.closest('.copy-email') : null;
    if(!el) return;
    e.preventDefault();
    var email = el.getAttribute('data-copy-email') || '';
    if(!email) return;
    el.setAttribute('data-copied-label', 'Copied!');
    function fallback(){
      try{
        var ta = document.createElement('textarea');
        ta.value = email; ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.focus(); ta.select();
        document.execCommand('copy'); document.body.removeChild(ta);
      }catch(err){}
      flash(el);
    }
    if(navigator.clipboard && navigator.clipboard.writeText){
      navigator.clipboard.writeText(email).then(function(){ flash(el); }, fallback);
    } else {
      fallback();
    }
  });
})();

/* ===== next block ===== */

(function(){
  var calc = document.getElementById('calc');
  if(!calc) return;

  var steps = calc.querySelectorAll('.calc-step');
  var TOTAL = 8; // question steps 0..7; 8 = review, 9 = done
  var cur = 0;
  var data = {};
  var stepN = document.getElementById('calcStepN');
  var prog = document.getElementById('calcProg');
  var backBtn = document.getElementById('calcBack');
  var nextBtn = document.getElementById('calcNext');
  var foot = document.getElementById('calcFoot');
  var summaryEl = document.getElementById('calcSummary');

  function show(i){
    steps.forEach(function(s){ s.classList.toggle('active', +s.dataset.step === i); });
    cur = i;
    backBtn.disabled = (i === 0 || i === 9);
    foot.style.display = (i === 9) ? 'none' : 'flex';
    if(i < TOTAL){
      stepN.textContent = 'Step ' + (i+1) + ' / ' + TOTAL;
      prog.style.width = (i/TOTAL)*100 + '%';
      nextBtn.innerHTML = (i === TOTAL-1) ? 'Review <span class="arrow">&rarr;</span>' : 'Continue <span class="arrow">&rarr;</span>';
    } else if(i === TOTAL){
      stepN.textContent = 'Review';
      prog.style.width = '100%';
      nextBtn.innerHTML = 'Send enquiry <span class="arrow">&rarr;</span>';
      buildSummary();
    }
  }

  calc.querySelectorAll('.calc-opts').forEach(function(grp){
    grp.querySelectorAll('.opt').forEach(function(btn){
      btn.addEventListener('click', function(){
        grp.querySelectorAll('.opt').forEach(function(o){ o.classList.remove('sel'); });
        btn.classList.add('sel');
        data[grp.dataset.key] = { q: grp.dataset.q, v: btn.dataset.val };
        setTimeout(function(){ if(cur < TOTAL) next(); }, 220);
      });
    });
  });

  function collectDetails(){
    data.name    = { q:'Full Name',     v:(document.getElementById('f_name').value||'').trim() };
    data.company = { q:'Company Name',  v:(document.getElementById('f_company').value||'').trim() };
    data.email   = { q:'Email Address', v:(document.getElementById('f_email').value||'').trim() };
    var _code=(document.getElementById('f_code')||{}).value||'';var _num=(document.getElementById('f_phone').value||'').trim();data.phone   = { q:'Phone Number',  v:(_num ? (_code+' '+_num).trim() : '') };
  }
  function collectLocation(){
    data.location = { q:'Country + City', v:(document.getElementById('f_location').value||'').trim() };
  }

  var ORDER = ['name','company','email','phone','biztype','locations','courts','placement','firstorder','sellsrecovery','location'];
  function escapeHtml(s){ return String(s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function buildSummary(){
    var rows='';
    ORDER.forEach(function(k){
      if(data[k] && data[k].v){
        rows += '<div class="row"><span class="k">'+data[k].q+'</span><span class="v">'+escapeHtml(data[k].v)+'</span></div>';
      }
    });
    summaryEl.innerHTML = rows || '<div class="row"><span class="v">No answers yet.</span></div>';
  }

  function next(){
    if(cur === 0){ collectDetails(); }
    if(cur === 7){ collectLocation(); }
    if(cur < TOTAL){ show(cur+1); }
    else if(cur === TOTAL){ sendEnquiry(); }
  }
  function back(){ if(cur>0 && cur<=TOTAL) show(cur-1); }

  function sendEnquiry(){
    var subject = 'New reseller enquiry' + (data.company && data.company.v ? ' (' + data.company.v + ')' : '');
    var fields = {};
    ORDER.forEach(function(k){ if(data[k] && data[k].v){ fields[data[k].q] = data[k].v; } });
    fields.name  = (data.name  && data.name.v)  || '';
    fields.email = (data.email && data.email.v) || '';
    if(nextBtn){ nextBtn.disabled = true; }
    window.pcsSubmit('enquiry', subject, fields);
  }
  window.__pcsEnquiryDone = function(){
    show(9);
    try{ calc.scrollIntoView({ block:'center' }); }catch(e){}
  }

  nextBtn.addEventListener('click', next);
  backBtn.addEventListener('click', back);
  show(0);
})();

/* ===== next block ===== */

(function(){
  var form = document.getElementById('preorderForm');
  if(!form) return;
  var done = document.getElementById('poDone');
  function mark(el,bad){ el.classList.toggle('err', bad); }
  var submitBtn = form.querySelector('.po-submit');
  var waBtn = document.getElementById('poWa');
  if(waBtn){
    var PO_WA = {
      en:function(q,n,em){ return 'Hi GOLF CARE! I\'d like to pre-order '+q+' GOLF CARE Stick'+(q>1?'s':'')+'. Name: '+n+'.'+(em?(' Email: '+em+'.'):''); },
      es:function(q,n,em){ return '\u00a1Hola GOLF CARE! Quiero reservar '+q+' GOLF CARE Stick'+(q>1?'s':'')+'. Nombre: '+n+'.'+(em?(' Email: '+em+'.'):''); },
      nl:function(q,n,em){ return 'Hoi GOLF CARE! Ik wil graag '+q+' GOLF CARE Stick'+(q>1?'s':'')+' pre-orderen. Naam: '+n+'.'+(em?(' E-mail: '+em+'.'):''); }
    };
    waBtn.addEventListener('click', function(){
      var name=document.getElementById('po_name'), email=document.getElementById('po_email'), qty=document.getElementById('po_qty');
      var bad=false;
      if(!name.value.trim()){ mark(name,true); bad=true; } else mark(name,false);
      var qn=parseInt(qty.value,10); if(!qn||qn<1){ mark(qty,true); bad=true; } else mark(qty,false);
      if(bad){ if(!name.value.trim()) name.focus(); return; }
      var fn = PO_WA[window.currentLang] || PO_WA.en;
      var msg = fn(qn, name.value.trim(), email.value.trim());
      window.open('https://wa.me/34682123662?text='+encodeURIComponent(msg), '_blank');
    });
  }
  form.addEventListener('submit', function(e){
    e.preventDefault();
    var name  = document.getElementById('po_name');
    var email = document.getElementById('po_email');
    var qty   = document.getElementById('po_qty');
    var bad = false;
    if(!name.value.trim()){ mark(name,true); bad = true; } else mark(name,false);
    var emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim());
    mark(email,!emailOk); if(!emailOk) bad = true;
    var q = parseInt(qty.value,10);
    if(!(q >= 1)){ mark(qty,true); bad = true; } else mark(qty,false);
    if(bad) return;

    if(submitBtn){ submitBtn.disabled = true; }
    window.pcsSubmit('preorder', 'New GOLF CARE pre-order', {
      name: name.value.trim(),
      email: email.value.trim(),
      quantity: String(q)
    });
  });
})();

/* ===== next block ===== */

/* ============================================================
   GOLF CARE — interactions
   ============================================================ */
(function(){
  "use strict";
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.addEventListener('touchstart', function(){}, {passive:true}); // enables :active tap feedback on iOS

  /* ---------- CONTENT IS VISIBLE WITHOUT A LOADING GATE ---------- */
  const loader = document.getElementById('loader');
  if(loader) loader.hidden = true;
  document.body.classList.remove('no-scroll');
  startReveals();

  /* ---------- LENIS SMOOTH SCROLL ---------- */
  let lenis = null;
  if(typeof Lenis !== 'undefined' && !reduceMotion && window.matchMedia('(min-width: 1281px) and (pointer: fine)').matches){
    lenis = new Lenis({ duration:1.15, easing:t=>Math.min(1,1.001-Math.pow(2,-10*t)), smoothWheel:true });
    function raf(time){ lenis.raf(time); requestAnimationFrame(raf); }
    requestAnimationFrame(raf);
    if(typeof ScrollTrigger !== 'undefined'){
      lenis.on('scroll', ScrollTrigger.update);
    }
  }
  // anchor smooth scroll
  document.querySelectorAll('a[href^="#"]').forEach(a=>{
    a.addEventListener('click', e=>{
      const id = a.getAttribute('href');
      if(id.length<2) return;
      const el = document.querySelector(id);
      if(!el) return;
      e.preventDefault();
      closeMenu(false);
      if(lenis) lenis.scrollTo(el, { offset:-20, duration:1.3 });
      else el.scrollIntoView({behavior:reduceMotion ? 'auto' : 'smooth'});
    });
  });

  const nav = document.getElementById('nav');
  const burger = document.getElementById('burger');
  const navLinks = document.getElementById('navLinks');
  const floatBuy = document.getElementById('floatBuy');
  const mobileMenu = window.matchMedia('(max-width: 1280px)');
  const shopSection = document.getElementById('shop');
  let lastY = window.scrollY;
  let menuY = 0;
  let shopVisible = false;
  let menuStyles = null;
  const menuParent = navLinks ? navLinks.parentNode : null;
  const menuNext = navLinks ? navLinks.nextSibling : null;

  function updateBuy(y){
    if(!floatBuy) return;
    const overlayOpen = document.querySelector('.ing-modal.open, .vid-modal.open');
    floatBuy.classList.toggle('show', y > window.innerHeight * 0.85 && !shopVisible && !menuStyles && !overlayOpen);
  }
  function onScroll(y){
    if(!nav) return;
    nav.classList.toggle('scrolled', y > 40);
    nav.classList.toggle('hide', !mobileMenu.matches && !menuStyles && y > lastY && y > 400);
    lastY = y;
    updateBuy(y);
  }
  function sizeMenu(){
    if(nav) document.documentElement.style.setProperty('--pcs-nav-height', nav.offsetHeight + 'px');
  }
  function syncMenuAccess(){
    if(!navLinks) return;
    if(mobileMenu.matches && navLinks.parentNode !== document.body) document.body.appendChild(navLinks);
    else if(!mobileMenu.matches && navLinks.parentNode !== menuParent) menuParent.insertBefore(navLinks, menuNext);
    const closed = mobileMenu.matches && !navLinks.classList.contains('open');
    navLinks.inert = closed;
    if(closed) navLinks.setAttribute('aria-hidden', 'true');
    else navLinks.removeAttribute('aria-hidden');
  }
  function closeMenu(restoreFocus){
    if(!navLinks || !burger || !nav) return;
    const wasOpen = navLinks.classList.contains('open');
    navLinks.classList.remove('open');
    nav.classList.remove('menu-open');
    document.body.classList.remove('pcs-menu-open');
    burger.setAttribute('aria-expanded', 'false');
    if(menuStyles){
      Object.keys(menuStyles).forEach(key => { document.body.style[key] = menuStyles[key]; });
      menuStyles = null;
      window.scrollTo(0, menuY);
      if(lenis) lenis.start();
    }
    syncMenuAccess();
    onScroll(wasOpen ? menuY : window.scrollY);
    if(wasOpen && restoreFocus) burger.focus({preventScroll:true});
  }
  function openMenu(){
    if(!mobileMenu.matches || !navLinks || !burger || !nav) return;
    menuY = window.scrollY;
    menuStyles = {};
    ['position','top','left','right','width','overflow'].forEach(key => { menuStyles[key] = document.body.style[key]; });
    if(lenis) lenis.stop();
    Object.assign(document.body.style, {position:'fixed',top:-menuY+'px',left:'0',right:'0',width:'100%',overflow:'hidden'});
    document.body.classList.add('pcs-menu-open');
    nav.classList.remove('hide');
    nav.classList.add('menu-open');
    navLinks.classList.add('open');
    burger.setAttribute('aria-expanded', 'true');
    syncMenuAccess();
    sizeMenu();
    updateBuy(menuY);
    requestAnimationFrame(() => {
      if(navLinks.classList.contains('open')) burger.focus({preventScroll:true});
    });
  }
  if(burger) burger.addEventListener('click', () => {
    if(navLinks.classList.contains('open')) closeMenu(true);
    else openMenu();
  });
  if(navLinks) navLinks.addEventListener('click', e => {
    if(e.target.closest('a[href]')) closeMenu(false);
  });
  document.addEventListener('keydown', e => {
    if(!menuStyles) return;
    if(e.key === 'Escape'){ e.preventDefault(); closeMenu(true); return; }
    if(e.key !== 'Tab') return;
    const controls = [burger, ...navLinks.querySelectorAll('a[href], button:not([disabled])')];
    const current = controls.indexOf(document.activeElement);
    e.preventDefault();
    const next = (current + (e.shiftKey ? -1 : 1) + controls.length) % controls.length;
    controls[next].focus();
  });
  window.addEventListener('resize', () => {
    if(!mobileMenu.matches) closeMenu(false);
    sizeMenu(); syncMenuAccess(); onScroll(menuStyles ? menuY : window.scrollY);
  }, {passive:true});
  if(lenis) lenis.on('scroll', ({scroll}) => onScroll(scroll));
  else window.addEventListener('scroll', () => { if(!menuStyles) onScroll(window.scrollY); }, {passive:true});
  if(shopSection) new IntersectionObserver(entries => {
    shopVisible = entries[0].isIntersecting;
    updateBuy(menuStyles ? menuY : window.scrollY);
  }).observe(shopSection);
  const overlayObserver = new MutationObserver(() => updateBuy(menuStyles ? menuY : window.scrollY));
  document.querySelectorAll('.ing-modal, .vid-modal').forEach(el => overlayObserver.observe(el, {attributes:true,attributeFilter:['class']}));
  sizeMenu(); syncMenuAccess(); onScroll(window.scrollY);

  /* ---------- MOUSE GLOW ---------- */
  const glow = document.getElementById('glow');
  let gx=window.innerWidth/2, gy=window.innerHeight/2, tx=gx, ty=gy;
  window.addEventListener('pointermove', e=>{ tx=e.clientX; ty=e.clientY; });
  (function glowLoop(){
    gx += (tx-gx)*0.12; gy += (ty-gy)*0.12;
    glow.style.transform = `translate(${gx}px,${gy}px) translate(-50%,-50%)`;
    requestAnimationFrame(glowLoop);
  })();

  /* ---------- REVEAL (IntersectionObserver) ---------- */
  function startReveals(){
    const io = new IntersectionObserver((entries)=>{
      entries.forEach(en=>{
        if(en.isIntersecting){ en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { threshold:0.14, rootMargin:'0px 0px -8% 0px' });
    document.querySelectorAll('.reveal').forEach(el=>io.observe(el));

    // counters
    document.querySelectorAll('[data-count]').forEach(el=>{
      const cio = new IntersectionObserver((ents)=>{
        ents.forEach(en=>{ if(en.isIntersecting){ countUp(el); cio.unobserve(el); } });
      },{threshold:0.5});
      cio.observe(el);
    });

    // steps timeline
    const steps = document.getElementById('steps');
    if(steps){
      const stepEls = steps.querySelectorAll('[data-step]');
      const fill = document.getElementById('tlFill');
      const sio = new IntersectionObserver((ents)=>{
        ents.forEach(en=>{
          if(en.isIntersecting){
            if(fill) fill.style.width='100%';
            stepEls.forEach((s,i)=>setTimeout(()=>s.classList.add('active'), 250*i));
            sio.disconnect();
          }
        });
      },{threshold:0.4});
      sio.observe(steps);
    }
  }
  function countUp(el){
    const target = parseFloat(el.getAttribute('data-count'));
    const dec = parseInt(el.getAttribute('data-dec')||'0',10);
    const suffix = el.querySelector('.suffix');
    el.textContent = '';
    const tnode = document.createTextNode('0');
    el.appendChild(tnode);
    if(suffix) el.appendChild(suffix);
    const dur = 1700, t0 = performance.now();
    (function step(now){
      const k = Math.min((now-t0)/dur, 1);
      const e = 1 - Math.pow(1-k, 3);
      tnode.nodeValue = (target*e).toFixed(dec);
      if(k<1) requestAnimationFrame(step);
      else tnode.nodeValue = target.toFixed(dec);
    })(performance.now());
  }

  /* ---------- FAQ ---------- */
  document.querySelectorAll('.faq-item').forEach(item=>{
    const q = item.querySelector('.faq-q');
    const a = item.querySelector('.faq-a');
    q.addEventListener('click',()=>{
      const open = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(o=>{ o.classList.remove('open'); o.querySelector('.faq-a').style.maxHeight=null; });
      if(!open){ item.classList.add('open'); a.style.maxHeight = a.scrollHeight+'px'; }
    });
  });

  /* ---------- GSAP PARALLAX ---------- */
  if(typeof gsap!=='undefined' && typeof ScrollTrigger!=='undefined' && !reduceMotion && window.matchMedia('(min-width: 1281px) and (pointer: fine)').matches){
    gsap.registerPlugin(ScrollTrigger);
    document.querySelectorAll('[data-parallax]').forEach(el=>{
      const amt = parseFloat(el.getAttribute('data-parallax'))||0.2;
      gsap.to(el,{ yPercent: amt*30, ease:'none',
        scrollTrigger:{ trigger:el.closest('section')||el, start:'top bottom', end:'bottom top', scrub:true }});
    });
  }

  /* ============================================================
     PRODUCT PHOTO — premium float, cursor tilt & drag-to-rotate
     ============================================================ */
  // HERO: gentle float + cursor-reactive 3D tilt
  (function(){
    const wrap = document.getElementById('hero-prod');
    if(!wrap) return;
    const img = wrap.querySelector('.prod-img');
    let tx=0, ty=0, cx=0, cy=0, t=0;
    window.addEventListener('pointermove', e=>{
      tx = (e.clientX/window.innerWidth - 0.5);
      ty = (e.clientY/window.innerHeight - 0.5);
    });
    (function loop(){
      requestAnimationFrame(loop);
      cx += (tx-cx)*0.06; cy += (ty-cy)*0.06; t += 0.016;
      const floatY = Math.sin(t*0.9)*10;
      const ry = cx*18 + Math.sin(t*0.5)*3;
      const rx = -cy*9;
      img.style.transform = `translateY(${floatY}px) perspective(1500px) rotateY(${ry}deg) rotateX(${rx}deg)`;
    })();
  })();

  // SHOWCASE: drag to rotate within a comfortable range + idle sway + momentum
  (function(){
    const stage = document.getElementById('show-stage');
    if(!stage || window.matchMedia('(pointer: coarse)').matches) return;
    const img = stage.querySelector('.prod-img');
    const px = e => e.touches ? e.touches[0].clientX : e.clientX;
    const py = e => e.touches ? e.touches[0].clientY : e.clientY;
    let dragging=false, lastX=0, lastY=0, vel=0, ry=0, rx=0, t=0;
    function down(e){ dragging=true; lastX=px(e); lastY=py(e); vel=0; stage.classList.add('grabbing'); }
    function move(e){
      if(!dragging) return;
      const x=px(e), y=py(e);
      vel = (x-lastX)*0.45; ry += vel;
      rx += (y-lastY)*0.12;
      lastX=x; lastY=y;
    }
    function up(){ dragging=false; stage.classList.remove('grabbing'); }
    stage.addEventListener('pointerdown',down);
    window.addEventListener('pointermove',move);
    window.addEventListener('pointerup',up);
    stage.addEventListener('touchstart',down,{passive:true});
    stage.addEventListener('touchmove',move,{passive:true});
    stage.addEventListener('touchend',up);
    (function loop(){
      requestAnimationFrame(loop);
      t += 0.016;
      if(!dragging){
        vel *= 0.90; ry += vel;
        const sway = Math.sin(t*0.45)*16;
        ry += (sway - ry)*0.012;
        rx += (0 - rx)*0.05;
      }
      // clamp to keep a single flat photo convincing (no edge-on flattening)
      ry = Math.max(-34, Math.min(34, ry));
      rx = Math.max(-16, Math.min(16, rx));
      const floatY = Math.sin(t*0.8)*8;
      img.style.transform = `translateY(${floatY}px) perspective(1600px) rotateY(${ry}deg) rotateX(${rx}deg)`;
    })();
  })();

  // INGREDIENT MODAL
  (function(){
    const data={
      menthol:{name:'Menthol',tag:'Active · Cooling',illus:'ill-menthol',
        what:'The naturally cooling compound found in mint plants.',
        how:'Activates the cold receptors in your skin for an instant fresh sensation that takes the edge off tired, aching muscles.'},
      camphor:{name:'Camphor',tag:'Active · Warming',illus:'ill-camphor',
        what:'An aromatic extract from the wood of the camphor tree.',
        how:'Gives a gentle warming glow and supports local circulation, balancing menthol\'s cooling for a soothing hot-and-cold effect.'},
      eucalyptus:{name:'Eucalyptus Oil',tag:'Active · Cooling',illus:'ill-eucalyptus',
        what:'An aromatic oil distilled from the leaves of the eucalyptus tree.',
        how:'Adds a clean, breathable freshness and a light cooling lift that works alongside menthol on tired, worked muscles.'},
      wintergreen:{name:'Wintergreen Oil',tag:'Active · Soothing',illus:'ill-wintergreen',
        what:'An aromatic plant oil that is a long-time classic in sports rubs.',
        how:'A natural source of soothing actives that help ease the feeling of tension in muscles and joints.'},
      capsaicin:{name:'Capsaicin',tag:'Active · Warming',illus:'ill-capsaicin',
        what:'The natural warming compound that gives chili peppers their heat.',
        how:'Creates a gentle warming sensation that draws focus away from stiff, aching spots and pairs with the cooling actives for a balanced hot-and-cold feel.'},
      arnica:{name:'Arnica Montana',tag:'Active · Soothing',illus:'ill-arnica',
        what:'A bright mountain flower (Arnica montana) trusted in natural muscle care for generations.',
        how:'Helps calm the feeling of strained, overworked muscles so you feel more comfortable after an intense match.'},
      calendula:{name:'Calendula',tag:'Active · Soothing',illus:'ill-calendula',
        what:'A golden marigold flower (Calendula officinalis) long valued in natural skin and body care.',
        how:'Helps soothe and condition skin that takes a beating on the course, keeping the area where you apply the stick calm and comfortable.'},
      jojoba:{name:'Jojoba Oil',tag:'Base · Nourishing',illus:'ill-jojoba',
        what:'A lightweight oil pressed from the seed of the jojoba plant — the main base of the balm.',
        how:'Carries the active ingredients and lets the balm glide on smoothly, so the formula absorbs clean without a greasy film.'},
      boswellia:{name:'Boswellia',tag:'Active · Anti-inflammatory',illus:'ill-boswellia',
        what:'An extract from the resin of the Boswellia serrata tree (Indian frankincense), rich in boswellic acids.',
        how:'Its boswellic acids help calm the inflammatory response in tired muscles and joints, supporting comfort and faster recovery after training.'},
      beeswax:{name:'Beeswax',tag:'Base · Natural',illus:'ill-beeswax',
        what:'A natural wax produced by honeybees.',
        how:'Forms the solid base of the stick and helps the actives stay exactly where you apply them — targeted and mess-free.'},
      vitaminE:{name:'Tocopherol (Vitamin E)',tag:'Base · Protective',illus:'ill-vitaminE',
        what:'A skin-loving antioxidant vitamin, also known as tocopherol.',
        how:'Helps protect and condition your skin against daily wear, keeping it soft where you apply the stick.'}
    };
    const modal=document.getElementById('ingModal');
    if(!modal) return;
    const elTag=document.getElementById('ingTag'),elTitle=document.getElementById('ingTitle'),
          elWhat=document.getElementById('ingWhat'),elHow=document.getElementById('ingHow'),
          elUse=document.getElementById('ingUse');
    let lastFocus=null;
    function openIng(id){
      const base=data[id]; if(!base) return; const t=(window.currentLang==='nl'&&window.__ingNL&&window.__ingNL[id])?window.__ingNL[id]:((window.currentLang==='es'&&window.__ingES&&window.__ingES[id])?window.__ingES[id]:base); const d={illus:base.illus,name:t.name,tag:t.tag,what:t.what,how:t.how}; if(!d) return;
      elTag.textContent=d.tag; elTitle.textContent=d.name;
      elWhat.textContent=d.what; elHow.textContent=d.how;
      elUse.setAttribute('href','#'+d.illus);
      elUse.setAttribute('xlink:href','#'+d.illus);
      modal.classList.add('open'); modal.setAttribute('aria-hidden','false');
      document.body.style.overflow='hidden'; if(lenis) lenis.stop();
      const c=modal.querySelector('.ing-close'); if(c) c.focus();
    }
    function closeIng(){
      modal.classList.remove('open'); modal.setAttribute('aria-hidden','true');
      document.body.style.overflow=''; if(lenis) lenis.start();
      if(lastFocus) lastFocus.focus();
    }
    document.querySelectorAll('.ing-card[data-ing]').forEach(card=>{
      card.addEventListener('click',()=>{lastFocus=card;openIng(card.getAttribute('data-ing'));});
      card.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();lastFocus=card;openIng(card.getAttribute('data-ing'));}});
    });
    modal.querySelectorAll('[data-close]').forEach(b=>b.addEventListener('click',closeIng));
    window.addEventListener('keydown',e=>{if(e.key==='Escape'&&modal.classList.contains('open'))closeIng();});
  })();

  // ============ I18N (EN / ES) ============
  (function(){
    const I18N_ES = {"free_ship": "Envío gratis", "pt_top": "Por stick", "hero_price_meta": "IVA incluido", "buy_t3": "Ingredientes naturales", "buy_t2": "Envío gratis", "buy_t1": "Pago seguro", "buy_sold": "Agotado", "buy_btn": "Comprar", "buy_vat": "IVA incluido", "buy_meta": "75 g · Bálsamo de recuperación en stick", "foot_family": "Parte de la familia Care Stick", "nav_perf": "Rendimiento", "nav_ing": "Ingredientes", "nav_how": "Cómo funciona", "nav_stick": "El stick", "nav_faq": "Preguntas", "nav_stockists": "Para clubes y tiendas", "nav_reseller": "Distribuidores", "nav_shop": "Comprar", "hero_eye": "La recuperación empieza aquí", "hero_h1": "Golf Care Stick<br><span class=\"l2\">Cuidado para tu deporte.</span>", "hero_sub": "Un bálsamo de recuperación premium creado para golfistas y deportistas: alivia los músculos, favorece la recuperación y ayuda a tu cuerpo a rendir al máximo.", "hero_shop": "Comprar <span class=\"arrow\">→</span>", "hero_learn": "Saber más", "scroll": "Desliza", "m_nourish": "Nutre", "m_relieve": "Alivia", "m_restore": "Restaura", "m_natural": "Ingredientes naturales", "m_muscles": "Para músculos y recuperación", "m_prr": "Rendir · Recuperar · Repetir", "ben_eye": "Cuida tu juego", "ben_h2": "Creado para que vuelvas más fuerte.", "ben_p": "Alivio específico para músculos, articulaciones e inflamación, diseñado para una recuperación más rápida tras cada ronda.", "ben1_h": "Alivia las molestias musculares", "ben1_p": "Acción localizada que ayuda a aliviar la tensión y el dolor allí donde más lo notas.", "ben2_h": "Favorece la recuperación", "ben2_p": "Estimula el proceso natural de recuperación del cuerpo entre sesiones y rondas.", "ben3_h": "Ingredientes naturales", "ben3_p": "Extractos vegetales y botánicos cuidadosamente seleccionados en una fórmula limpia y pensada.", "ben4_h": "Apoyo antiinflamatorio", "ben4_p": "Ayuda al cuerpo a calmar la inflamación para que te recuperes antes.", "the_formula": "La fórmula", "ing_h2": "Once ingredientes. Un stick preciso.", "ing_p": "Cada ingrediente se gana su lugar: elegido por cómo se siente, cómo actúa y cómo trabaja con tu cuerpo.", "ing_arnica_h": "Árnica montana", "ing_arnica_p": "Usada tradicionalmente para aliviar los músculos sobrecargados y la tensión diaria.", "ing_menthol_h": "Mentol", "ing_menthol_p": "Aporta una sensación de frescor inmediata que calma las piernas cansadas y pesadas.", "ing_camphor_h": "Alcanfor", "ing_camphor_p": "Un contrapunto cálido que favorece la circulación y un confort duradero.", "ing_wg_h": "Aceite de gaulteria", "ing_wg_p": "Una fuente botánica de activos calmantes naturales para el cuerpo activo.", "ing_pm_h": "Menta", "ing_pm_p": "Un toque aromático refrescante que revitaliza los sentidos entre puntos.", "ing_ve_h": "Tocoferol (Vit. E)", "ing_ve_p": "Un antioxidante que ayuda a proteger y cuidar la piel sometida a esfuerzo.", "ing_jj_h": "Aceite de jojoba", "ing_jj_p": "Una nutrición ligera que se desliza suavemente sin dejar grasa.", "ing_bw_h": "Cera de abejas", "ing_bw_p": "Una base natural que mantiene la fórmula justo donde la aplicas.", "ing_eu_h": "Aceite de eucalipto", "ing_eu_p": "Frescor limpio y respirable con un ligero efecto refrescante.", "ing_cap_h": "Capsaicina", "ing_cap_p": "Un suave toque de calor que equilibra los activos refrescantes.", "ing_cal_h": "Caléndula", "ing_cal_p": "Una flor que calma la piel y mantiene cómoda la zona de aplicación.", "ing_bos_h": "Boswellia", "ing_bos_p": "Extracto de resina de incienso, rico en ácidos boswélicos que ayudan a calmar la inflamación.", "how_eye": "Aplicación", "how_h2": "Tres segundos para recuperarte.", "how1_h": "Aplica", "how1_p": "Desliza el stick directamente sobre los músculos, articulaciones y zonas problemáticas.", "how2_h": "Masajea", "how2_p": "Trabájalo con una ligera presión hasta que se absorba por completo en la piel.", "how3_h": "Recupérate", "how3_p": "Siéntete fresco, suelto y listo para la próxima ronda, sin manchas.", "ath_eye": "En el campo", "ath_h2": "Ataca el dolor.<br>Acelera la recuperación.", "ath_lead": "Del campo de golf al gimnasio, GOLF CARE va directo a los músculos y articulaciones que se llevan el golpe, aliviando las molestias para que sigas rindiendo a tu nivel.", "chip1": "Golfistas", "chip2": "Tenistas", "chip3": "Atletas fitness", "chip4": "Entrenamiento diario", "fig_badge": "Antes y después de la ronda", "test_eye": "El veredicto", "test_h2": "Recuperación en la que confían los deportistas.", "test1_q": "\"Tengo uno en la bolsa de golf y otro en el coche. El frescor tras una ronda larga es increíble: mis piernas amanecen listas.\"", "test1_r": "Golfista · Madrid", "test2_q": "\"Ya se lo recomiendo a la mitad de mis clientes. Ingredientes limpios, sin grasa, y se absorbe de verdad. El formato stick es genial para el campo.\"", "test2_r": "Pro de golf · Barcelona", "test3_q": "\"Jugar dobles tres veces por semana me destroza los hombros. Una pasada antes y después y la rigidez mejora notablemente. Y se siente premium.\"", "test3_r": "Golfista amateur · Ámsterdam", "cmp_eye": "La diferencia", "cmp_h2": "No es una crema muscular cualquiera.", "cmp_p": "Descubre por qué los deportistas cambian los tubos sucios y los geles genéricos por el GOLF CARE STICK.", "cmp_feature": "Característica", "cmp_generic": "Bálsamo genérico", "cmp_r1": "Hecho para golfistas", "cmp_r2": "Formato stick portátil", "cmp_r3": "Aplicación sin manchas", "cmp_r4": "Sensación refrescante inmediata", "cmp_r5": "Aplicación localizada", "cmp_r6": "Ingredientes naturales premium", "cmp_r7": "Cabe en cualquier bolsa de golf", "cmp_r8": "Uso antes y después de la ronda", "cmp_varies": "Varía", "cmp_slow": "Lento", "sc_eye": "El producto", "sc_h2": "El GOLF CARE Stick.", "sc_p": "Un bálsamo de recuperación de precisión en un práctico stick giratorio. Sin manchas ni manos grasientas: desliza, listo y a recuperar. Diseñado para vivir en tu bolsa y acompañarte allí donde juegues.", "sc_k1": "Formato", "sc_v1": "Stick de bálsamo giratorio", "sc_k2": "Peso neto", "sc_k3": "Botánicos activos", "sc_v3": "11 ingredientes", "sc_k4": "Uso", "sc_v4": "Antes y después de jugar", "sc_k5": "Apto para", "sc_v5": "Uso diario", "sc_get": "Comprar <span class=\"arrow\">→</span>", "drag": "Arrastra para girar", "faq_eye": "Preguntas", "faq_h2": "Todo lo que necesitas saber.", "faq1_q": "¿Cuándo debo usar el GOLF CARE Stick?", "faq1_a": "Úsalo antes de jugar para preparar las zonas clave y después para favorecer la recuperación. Muchos deportistas también lo aplican por la noche sobre los músculos cansados. Es lo bastante suave para un uso diario.", "faq2_q": "¿Cómo se aplica?", "faq2_a": "Gira el bálsamo y deslízalo directamente sobre los músculos o articulaciones que quieras tratar. Masajéalo con una ligera presión hasta que se absorba. No hace falta frotarlo entre las manos: esa es la ventaja del formato stick.", "faq3_q": "¿Qué contiene exactamente?", "faq3_a": "Una fórmula limpia de origen vegetal con siete activos botánicos —mentol, alcanfor, aceite de eucalipto, aceite de gaulteria, capsaicina, árnica montana y caléndula— sobre una base nutritiva de aceite de jojoba, cera de abejas y tocoferol (vitamina E). Seleccionados con cuidado por cómo se sienten y actúan en el cuerpo activo.", "faq4_q": "¿Es solo para golfistas?", "faq4_a": "Para nada. Se desarrolló pensando en el golf, pero funciona de maravilla para tenistas, gente de gimnasio, corredores y cualquiera que exija a su cuerpo y quiera recuperarse mejor.", "faq5_q": "¿Deja sensación grasienta o mancha?", "faq5_a": "No. El stick se desliza y se absorbe de forma limpia, sin dejarte las manos grasientas. Por eso es perfecto para usar en el campo: aplica, baja el bálsamo, tapa y de vuelta a la bolsa.", "faq6_q": "¿Cuánto dura un stick?", "faq6_a": "Cada stick son 75 g de bálsamo concentrado. Con un uso habitual un par de veces por semana, suele durar bastante más de un mes.", "stk_eye": "Para clubes y tiendas", "stk_h2": "Vende GOLF CARE en tu club o tienda.", "stk_p": "Clubes de golf, pro shops y tiendas de deporte: ofrece a tus jugadores un ritual de recuperación al que volverán. Nuestro expositor llega listo para el mostrador y se vende solo en el punto de juego.", "stk_b1": "Expositor listo para mostrador", "stk_s1": "Llega completo y con la marca: solo colócalo junto a la caja.", "stk_b2": "Márgenes atractivos", "stk_s2": "Precio premium con condiciones mayoristas atractivas para socios.", "stk_b3": "Confianza de clubes y jugadores", "stk_s3": "Una marca premium que tus socios ya quieren en la estantería.", "stk_badge": "Expositor para tienda", "stk_btn": "Conviértete en distribuidor <span class=\"arrow\">→</span>", "fin_eye": "Compra ahora", "fin_h2": "Tu recuperación<br><em>importa.</em>", "fin_p": "Un stick, 75 g de bálsamo de recuperación concentrado. Pide hoy y te lo enviamos directamente a casa.", "fin_btn": "Consigue tu GOLF CARE Stick <span class=\"arrow\">→</span>", "foot_p": "Bálsamo de recuperación premium para golfistas y deportistas. La recuperación empieza aquí.", "foot_product": "Producto", "foot_company": "Empresa", "foot_connect": "Conecta", "foot_benefits": "Beneficios", "foot_athletes": "Atletas", "foot_reviews": "Opiniones", "foot_shop": "Tienda", "foot_contact": "Contacto", "foot_news": "Boletín", "foot_rights": "© 2026 GOLF CARE. Todos los derechos reservados.", "foot_tag": "Nutre · Alivia · Restaura · Calma", "float_buy": "<span class=\"dot\"></span> Comprar", "mod_what": "Qué es", "mod_how": "Cómo actúa", "po_name": "Tu nombre", "po_email": "Correo electrónico", "po_qty": "¿Cuántas unidades quieres reservar?", "po_send": "Enviar reserva <span class=\"arrow\">→</span>", "po_note": "Al pulsar enviar, tu reserva se envía directamente a nuestro equipo, sin abrir ninguna app de correo.", "po_thanks": "¡Gracias!", "po_thanks_p": "Hemos recibido tu reserva y nos pondremos en contacto pronto. ¿Dudas? Escríbenos a <a href=\"#\" class=\"copy-email\" data-copy-email=\"info@golfcarestick.com\" title=\"Click to copy email address\">info@golfcarestick.com</a>.", "rev_cta": "Escribir una reseña", "rev_rating": "Tu puntuación", "rev_name": "Tu nombre", "rev_text": "Tu reseña", "rev_submit": "Publicar reseña <span class=\"arrow\">→</span>", "wa_label": "Respuesta más rápida por WhatsApp", "wa_btn": "Chatea por WhatsApp", "em_label": "Respuesta en 1 día", "em_btn": "Escríbenos", "po_wa": "Reservar por WhatsApp", "po_or": "o", "nav_blog": "Blog"};
    const ING_ES = {"arnica": {"name": "Árnica", "tag": "Calmante", "what": "Una vistosa flor de montaña (Arnica montana) que se usa en el cuidado muscular natural desde hace generaciones.", "how": "Ayuda a calmar la sensación de músculos forzados y sobrecargados para que estés más cómodo tras una ronda intensa."}, "menthol": {"name": "Mentol", "tag": "Refrescante", "what": "El compuesto naturalmente refrescante que se encuentra en la menta.", "how": "Activa los receptores de frío de la piel para una sensación fresca inmediata que alivia los músculos cansados y doloridos."}, "camphor": {"name": "Alcanfor", "tag": "Calor", "what": "Un extracto aromático de la madera del árbol del alcanfor.", "how": "Aporta un suave calor y favorece la circulación local, equilibrando el frescor del mentol para un efecto frío-calor reconfortante."}, "wintergreen": {"name": "Gaulteria", "tag": "Calmante", "what": "Una planta aromática cuyo aceite es un clásico en las cremas deportivas.", "how": "Una fuente natural de activos calmantes que ayudan a aliviar la sensación de tensión en músculos y articulaciones."}, "peppermint": {"name": "Menta", "tag": "Refrescante", "what": "Una hierba fresca y aromática naturalmente rica en mentol.", "how": "Aporta un toque limpio y refrescante y un ligero cosquilleo frío que revitaliza las piernas cansadas entre puntos."}, "vitaminE": {"name": "Vitamina E", "tag": "Protector", "what": "Una vitamina antioxidante que cuida la piel.", "how": "Ayuda a proteger y acondicionar la piel frente al desgaste diario, manteniéndola suave allí donde aplicas el stick."}, "jojoba": {"name": "Aceite de jojoba", "tag": "Nutritivo", "what": "Un aceite ligero prensado de la semilla de la jojoba.", "how": "Permite que el bálsamo se deslice suavemente y nutre la piel, de modo que la fórmula se absorbe limpia y sin grasa."}, "beeswax": {"name": "Cera de abejas", "tag": "Base natural", "what": "Una cera natural producida por las abejas.", "how": "Forma la base sólida del stick y ayuda a que los activos se queden justo donde los aplicas: preciso y sin manchas."}, "eucalyptus": {"name": "Aceite de eucalipto", "tag": "Activo · Refrescante", "what": "Un aceite aromático destilado de las hojas del eucalipto.", "how": "Aporta un frescor limpio y ligero que acompaña al mentol en los músculos cansados y trabajados."}, "capsaicin": {"name": "Capsaicina", "tag": "Activo · Calor", "what": "El compuesto natural que da su picor a los chiles.", "how": "Crea una suave sensación de calor que distrae de las zonas rígidas y, junto a los activos refrescantes, logra un efecto frío-calor equilibrado."}, "calendula": {"name": "Caléndula", "tag": "Activo · Calmante", "what": "Una flor dorada (Calendula officinalis) muy valorada en el cuidado natural de la piel.", "how": "Ayuda a calmar y cuidar la piel castigada por el juego, manteniendo cómoda la zona donde aplicas el stick."}, "boswellia": {"name": "Boswellia", "tag": "Activo · Antiinflamatorio", "what": "Un extracto de la resina del árbol Boswellia serrata (incienso indio), rico en ácidos boswélicos.", "how": "Sus ácidos boswélicos ayudan a calmar la respuesta inflamatoria en músculos y articulaciones cansados, favoreciendo el confort y una recuperación más rápida tras el ejercicio."}};
    window.__ingES = ING_ES;
    const I18N_NL = {"free_ship": "Gratis verzending", "pt_top": "Per stick", "hero_price_meta": "incl. btw", "buy_t3": "Natuurlijke ingrediënten", "buy_t2": "Gratis verzending", "buy_t1": "Veilig afrekenen", "buy_sold": "Uitverkocht", "buy_btn": "Kopen", "buy_vat": "incl. btw", "buy_meta": "75 g · Herstelbalsem in stick", "foot_family": "Onderdeel van de Care Stick familie", "nav_perf": "Prestaties", "nav_ing": "Ingrediënten", "nav_how": "Hoe het werkt", "nav_stick": "De stick", "nav_faq": "Vragen", "nav_stockists": "Voor clubs & winkels", "nav_reseller": "Resellers", "nav_shop": "Kopen", "hero_eye": "Herstel begint hier", "hero_h1": "Golf Care Stick<br><span class=\"l2\">Verzorging voor jouw sportmoment.</span>", "hero_sub": "Een premium herstelbalsem ontwikkeld voor golfers en sporters — om spieren te verzachten, herstel te ondersteunen en je lichaam optimaal te laten presteren.", "hero_shop": "Kopen <span class=\"arrow\">→</span>", "hero_learn": "Meer weten", "scroll": "Scroll", "m_nourish": "Voedt", "m_relieve": "Verlicht", "m_restore": "Herstelt", "m_natural": "Natuurlijke ingrediënten", "m_muscles": "Voor spieren & herstel", "m_prr": "Presteren · Herstellen · Herhalen", "ben_eye": "Zorg voor je spel", "ben_h2": "Gemaakt om je sterker terug te brengen.", "ben_p": "Gerichte verlichting voor spieren, gewrichten en ontstekingen — ontworpen voor sneller herstel na elke ronde.", "ben1_h": "Verlicht spierongemak", "ben1_p": "Gerichte werking die spanning en pijn helpt verlichten, precies waar je het het meest voelt.", "ben2_h": "Ondersteunt herstel", "ben2_p": "Stimuleert het natuurlijke herstelproces van het lichaam tussen sessies en rondes door.", "ben3_h": "Natuurlijke ingrediënten", "ben3_p": "Zorgvuldig gekozen plantenextracten en botanicals in een schone, doordachte formule.", "ben4_h": "Ontstekingsremmende ondersteuning", "ben4_p": "Helpt het lichaam ontstekingen te kalmeren zodat je sneller herstelt.", "the_formula": "De formule", "ing_h2": "Elf ingrediënten. Eén precieze stick.", "ing_p": "Elk ingrediënt verdient zijn plek — gekozen om hoe het voelt, presteert en samenwerkt met je lichaam.", "ing_arnica_h": "Arnica montana", "ing_arnica_p": "Traditioneel gebruikt om overbelaste spieren te verzachten en dagelijkse spanning te verlichten.", "ing_menthol_h": "Menthol", "ing_menthol_p": "Geeft een direct verkoelend gevoel dat vermoeide, zware benen kalmeert.", "ing_camphor_h": "Kamfer", "ing_camphor_p": "Een verwarmend tegenwicht dat de doorbloeding ondersteunt en langdurig comfort biedt.", "ing_wg_h": "Wintergroenolie", "ing_wg_p": "Een botanische bron van natuurlijk verzachtende stoffen voor het actieve lichaam.", "ing_pm_h": "Pepermunt", "ing_pm_p": "Een verfrissend aromatisch accent dat de zintuigen tussen de punten oppept.", "ing_ve_h": "Tocoferol (Vit. E)", "ing_ve_p": "Een antioxidant die de huid onder belasting helpt beschermen en verzorgen.", "ing_jj_h": "Jojoba-olie", "ing_jj_p": "De belangrijkste basisolie — lichte voeding die soepel uitstrijkt zonder vet gevoel.", "ing_bw_h": "Bijenwas", "ing_bw_p": "Een natuurlijke basis die de formule precies houdt waar je hem aanbrengt.", "ing_eu_h": "Eucalyptusolie", "ing_eu_p": "Schone, ademende frisheid met een lichte verkoelende lift.", "ing_cap_h": "Capsaïcine", "ing_cap_p": "Een zachte verwarmende prikkel die de verkoelende stoffen in balans brengt.", "ing_cal_h": "Goudsbloem", "ing_cal_p": "Een huidverzachtende bloem die het aangebrachte gebied kalm en comfortabel houdt.", "ing_bos_h": "Boswellia", "ing_bos_p": "Wierook-harsextract, rijk aan boswelliazuren die ontstekingen helpen kalmeren.", "how_eye": "Toepassing", "how_h2": "Drie seconden tot herstel.", "how1_h": "Aanbrengen", "how1_p": "Strijk de stick direct over spieren, gewrichten en probleemzones.", "how2_h": "Masseren", "how2_p": "Masseer met lichte druk in tot het volledig in de huid is opgenomen.", "how3_h": "Herstellen", "how3_p": "Voel je fris, soepel en klaar voor de volgende ronde — zonder rommel.", "ath_eye": "Gedragen op de baan", "ath_h2": "Pak de pijn aan.<br>Versnel het herstel.", "ath_lead": "Van de golfbaan tot de sportschoolvloer — GOLF CARE gaat recht op de spieren en gewrichten af die de klappen opvangen, en verlicht ongemak zodat je op niveau blijft bewegen.", "chip1": "Golfers", "chip2": "Tennissers", "chip3": "Fitnessatleten", "chip4": "Dagelijkse training", "fig_badge": "Voor & na de ronde", "test_eye": "Het oordeel", "test_h2": "Herstel waar atleten op zweren.", "test1_q": "\"Ik heb er één in mijn golftas en één in de auto. De verkoeling na een lange ronde is ongelofelijk — mijn benen voelen de volgende ochtend fris.\"", "test1_r": "Golfer · Madrid", "test2_q": "\"Ik raad het inmiddels de helft van mijn klanten aan. Schone ingrediënten, geen vette troep, en het trekt echt in. Het stickformaat is geniaal voor naast de baan.\"", "test2_r": "Tenniscoach · Barcelona", "test3_q": "\"Drie keer per week dubbelen sloopt mijn schouders. Even een veeg ervoor en erna en de stijfheid is merkbaar beter. Voelt ook premium.\"", "test3_r": "Amateurgolfer · Amsterdam", "cmp_eye": "Het verschil", "cmp_h2": "Niet zomaar een spiercrème.", "cmp_p": "Ontdek waarom atleten overstappen van rommelige tubes en generieke gels naar de GOLF CARE STICK.", "cmp_feature": "Kenmerk", "cmp_generic": "Generieke balsem", "cmp_r1": "Gemaakt voor golfers", "cmp_r2": "Draagbaar stickformaat", "cmp_r3": "Aanbrengen zonder rommel", "cmp_r4": "Snel verkoelend gevoel", "cmp_r5": "Gerichte toepassing", "cmp_r6": "Premium natuurlijke ingrediënten", "cmp_r7": "Past in elke golftas", "cmp_r8": "Gebruik voor & na de ronde", "cmp_varies": "Wisselend", "cmp_slow": "Traag", "sc_eye": "Het product", "sc_h2": "De GOLF CARE Stick.", "sc_p": "Een precieze herstelbalsem in een schone draaistick. Geen rommel, geen vette handen — gewoon aanbrengen, gaan en herstellen. Ontworpen om in je sporttas te leven en mee te reizen waar je spel je ook brengt.", "sc_k1": "Formaat", "sc_v1": "Draaibare balsemstick", "sc_k2": "Netto gewicht", "sc_k3": "Actieve botanicals", "sc_v3": "11 ingrediënten", "sc_k4": "Gebruik", "sc_v4": "Voor & na het spelen", "sc_k5": "Geschikt voor", "sc_v5": "Dagelijks gebruik", "sc_get": "Kopen <span class=\"arrow\">→</span>", "drag": "Sleep om te draaien", "faq_eye": "Vragen", "faq_h2": "Alles wat je moet weten.", "faq1_q": "Wanneer gebruik ik de GOLF CARE Stick?", "faq1_a": "Gebruik hem voor het spelen om de belangrijkste zones voor te bereiden, en erna om herstel te ondersteunen. Veel sporters brengen hem 's avonds ook aan op vermoeide spieren. Hij is mild genoeg voor dagelijks gebruik.", "faq2_q": "Hoe breng ik hem aan?", "faq2_a": "Draai de balsem omhoog en strijk hem direct over de spieren of gewrichten die je wilt behandelen. Masseer in met lichte druk tot het is opgenomen. Je hoeft niets tussen je handen te wrijven — dat is juist het voordeel van het stickformaat.", "faq3_q": "Wat zit er precies in?", "faq3_a": "Een schone, plantaardige formule met zeven actieve botanicals — menthol, kamfer, eucalyptusolie, wintergroenolie, capsaïcine, arnica montana en goudsbloem — op een voedende basis van jojoba-olie, bijenwas en tocoferol (vitamine E). Zorgvuldig gekozen om hoe ze voelen en werken op het actieve lichaam.", "faq4_q": "Is het alleen voor golfers?", "faq4_a": "Zeker niet. Het is ontwikkeld met golf in gedachten, maar werkt geweldig voor tennissers, sportschoolgangers, hardlopers en iedereen die zijn lichaam belast en beter wil herstellen.", "faq5_q": "Laat het een vet gevoel of vlekken achter?", "faq5_a": "Nee. De stick glijdt en trekt schoon in, zonder je handen vet te maken. Daarom is hij perfect voor naast de baan: aanbrengen, balsem terugdraaien, dop erop en terug in de tas.", "faq6_q": "Hoe lang gaat een stick mee?", "faq6_a": "Elke stick bevat 75 g geconcentreerde balsem. Bij normaal gebruik van een paar keer per week gaat hij doorgaans ruim langer dan een maand mee.", "stk_eye": "Voor clubs & winkels", "stk_h2": "Verkoop GOLF CARE in je club of winkel.", "stk_p": "Golfclubs, pro shops en sportwinkels: bied je spelers een herstelritueel waar ze voor terugkomen. Onze display arriveert kant-en-klaar voor de toonbank en verkoopt zichzelf op de plek waar gespeeld wordt.", "stk_b1": "Kant-en-klare toonbankdisplay", "stk_s1": "Komt compleet en met merk binnen — zet hem gewoon naast de kassa.", "stk_b2": "Aantrekkelijke marges", "stk_s2": "Premium prijs met aantrekkelijke groothandelsvoorwaarden voor partners.", "stk_b3": "Vertrouwd door clubs & spelers", "stk_s3": "Een premium merk dat je leden al op de plank willen zien.", "stk_badge": "Winkeldisplay", "stk_btn": "Word reseller <span class=\"arrow\">→</span>", "fin_eye": "Koop nu", "fin_h2": "Jouw herstel<br><em>telt.</em>", "fin_p": "Eén stick, 75 g geconcentreerde herstelbalsem. Bestel vandaag en we sturen hem rechtstreeks naar je deur.", "fin_btn": "Bestel jouw GOLF CARE Stick <span class=\"arrow\">→</span>", "foot_p": "Premium herstelbalsem voor golfers en sporters. Herstel begint hier.", "foot_product": "Product", "foot_company": "Bedrijf", "foot_connect": "Connect", "foot_benefits": "Voordelen", "foot_athletes": "Atleten", "foot_reviews": "Reviews", "foot_shop": "Shop", "foot_contact": "Contact", "foot_news": "Nieuwsbrief", "foot_rights": "© 2026 GOLF CARE. Alle rechten voorbehouden.", "foot_tag": "Voedt · Verlicht · Herstelt · Kalmeert", "float_buy": "<span class=\"dot\"></span> Kopen", "mod_what": "Wat het is", "mod_how": "Hoe het werkt", "po_name": "Je naam", "po_email": "E-mailadres", "po_qty": "Hoeveel stuks wil je reserveren?", "po_send": "Reservering versturen <span class=\"arrow\">→</span>", "po_note": "Als je op versturen drukt, gaat je reservering direct naar ons team — er wordt geen mailapp geopend.", "po_thanks": "Bedankt!", "po_thanks_p": "We hebben je reservering ontvangen en nemen snel contact op. Vragen? Mail ons op <a href=\"#\" class=\"copy-email\" data-copy-email=\"info@golfcarestick.com\" title=\"Click to copy email address\">info@golfcarestick.com</a>.", "rev_cta": "Schrijf een review", "rev_rating": "Jouw score", "rev_name": "Je naam", "rev_text": "Je review", "rev_submit": "Plaats review <span class=\"arrow\">→</span>", "wa_label": "Sneller antwoord via WhatsApp", "wa_btn": "Chat via WhatsApp", "em_label": "Antwoord binnen 1 dag", "em_btn": "Mail ons", "po_wa": "Pre-order via WhatsApp", "po_or": "of", "nav_blog": "Blog"};
    const ING_NL = {"arnica": {"name": "Arnica", "tag": "Verzachtend", "what": "Een opvallende bergbloem (Arnica montana) die al generaties wordt gebruikt in natuurlijke spierverzorging.", "how": "Helpt het gevoel van overbelaste, geforceerde spieren te kalmeren zodat je je comfortabeler voelt na een intense ronde."}, "menthol": {"name": "Menthol", "tag": "Verkoelend", "what": "De van nature verkoelende stof die in muntplanten voorkomt.", "how": "Activeert de koudereceptoren in de huid voor een direct fris gevoel dat vermoeide, pijnlijke spieren verlicht."}, "camphor": {"name": "Kamfer", "tag": "Warmte", "what": "Een aromatisch extract uit het hout van de kamferboom.", "how": "Geeft een zachte warmte en ondersteunt de lokale doorbloeding, in balans met de frisheid van menthol voor een verkwikkend koud-warm effect."}, "wintergreen": {"name": "Wintergroen", "tag": "Verzachtend", "what": "Een aromatische plant waarvan de olie een klassieker is in sportcrèmes.", "how": "Een natuurlijke bron van verzachtende stoffen die het gevoel van spanning in spieren en gewrichten helpen verlichten."}, "peppermint": {"name": "Pepermunt", "tag": "Verkoelend", "what": "Een frisse, aromatische kruidenplant van nature rijk aan menthol.", "how": "Geeft een schoon, verfrissend accent en een lichte koude tinteling die vermoeide benen tussen de punten oppept."}, "vitaminE": {"name": "Vitamine E", "tag": "Beschermend", "what": "Een antioxiderende vitamine die de huid verzorgt.", "how": "Helpt de huid te beschermen en verzorgen tegen dagelijkse belasting en houdt hem zacht waar je de stick aanbrengt."}, "jojoba": {"name": "Jojoba-olie", "tag": "Voedend", "what": "Een lichte olie geperst uit de jojobazaad.", "how": "Laat de balsem soepel uitglijden en voedt de huid, zodat de formule schoon en vetvrij intrekt."}, "beeswax": {"name": "Bijenwas", "tag": "Natuurlijke basis", "what": "Een natuurlijke was geproduceerd door bijen.", "how": "Vormt de vaste basis van de stick en helpt de actieve stoffen precies te houden waar je ze aanbrengt — nauwkeurig en zonder rommel."}, "eucalyptus": {"name": "Eucalyptusolie", "tag": "Actief · Verkoelend", "what": "Een aromatische olie gedestilleerd uit eucalyptusbladeren.", "how": "Geeft een schone, lichte frisheid die de menthol begeleidt op vermoeide, belaste spieren."}, "capsaicin": {"name": "Capsaïcine", "tag": "Actief · Warmte", "what": "De natuurlijke stof die pepers hun scherpte geeft.", "how": "Creëert een zacht warmtegevoel dat afleidt van stijve zones en, samen met de verkoelende stoffen, een gebalanceerd koud-warm effect geeft."}, "calendula": {"name": "Goudsbloem", "tag": "Actief · Verzachtend", "what": "Een gouden bloem (Calendula officinalis) zeer gewaardeerd in natuurlijke huidverzorging.", "how": "Helpt de door de baan belaste huid te kalmeren en verzorgen, en houdt het gebied waar je de stick aanbrengt comfortabel."}, "boswellia": {"name": "Boswellia", "tag": "Actief · Ontstekingsremmend", "what": "Een extract uit de hars van de Boswellia serrata-boom (Indiase wierook), rijk aan boswelliazuren.", "how": "De boswelliazuren helpen de ontstekingsreactie in vermoeide spieren en gewrichten te kalmeren, voor meer comfort en sneller herstel na inspanning."}};
    window.__ingNL = ING_NL;
    const nodes = Array.from(document.querySelectorAll('[data-i18n]'));
    nodes.forEach(el=>{ if(!el.hasAttribute('data-en')) el.setAttribute('data-en', el.innerHTML); });
    function setLang(lang){
      window.currentLang = lang;
      document.documentElement.lang = lang;
      nodes.forEach(el=>{
        const k = el.getAttribute('data-i18n');
        const translated = lang==='nl' && I18N_NL[k]!=null ? I18N_NL[k]
          : lang==='es' && I18N_ES[k]!=null ? I18N_ES[k] : el.getAttribute('data-en');
        if(el.innerHTML !== translated) el.innerHTML = translated;
      });
      document.querySelectorAll('.ing-card').forEach(c=>{
        c.setAttribute('data-hint', lang==='nl' ? 'Bekijk ingrediënt →' : (lang==='es' ? 'Ver ingrediente →' : 'View ingredient →'));
      });
      document.querySelectorAll('.lang-btn').forEach(b=>{
        b.classList.toggle('active', b.getAttribute('data-lang')===lang);
      });
    }
    window.setLang = setLang;
    document.querySelectorAll('.lang-btn').forEach(b=>{
      b.addEventListener('click', (event)=> { if(b.getAttribute('data-language-url')) return; event.preventDefault(); setLang(b.getAttribute('data-lang')); } );
    });
    setLang((document.documentElement.lang || 'en').split('-')[0]);
  })();

  // refresh ScrollTrigger after load
  window.addEventListener('load',()=>{ if(typeof ScrollTrigger!=='undefined') ScrollTrigger.refresh(); });
})();

/* ===== next block ===== */

/* Custom country-code dropdown (flag + dial code) — replaces the native select
   so the options are always readable instead of showing as a blank white bar. */
(function(){
  var COUNTRIES = [
    {f:'🇪🇸',n:'Spain',d:'+34'},{f:'🇳🇱',n:'Netherlands',d:'+31'},{f:'🇧🇪',n:'Belgium',d:'+32'},
    {f:'🇩🇪',n:'Germany',d:'+49'},{f:'🇫🇷',n:'France',d:'+33'},{f:'🇬🇧',n:'United Kingdom',d:'+44'},
    {f:'🇵🇹',n:'Portugal',d:'+351'},{f:'🇮🇹',n:'Italy',d:'+39'},{f:'🇮🇪',n:'Ireland',d:'+353'},
    {f:'🇦🇹',n:'Austria',d:'+43'},{f:'🇨🇭',n:'Switzerland',d:'+41'},{f:'🇸🇪',n:'Sweden',d:'+46'},
    {f:'🇳🇴',n:'Norway',d:'+47'},{f:'🇩🇰',n:'Denmark',d:'+45'},{f:'🇫🇮',n:'Finland',d:'+358'},
    {f:'🇵🇱',n:'Poland',d:'+48'},{f:'🇨🇿',n:'Czechia',d:'+420'},{f:'🇭🇺',n:'Hungary',d:'+36'},
    {f:'🇬🇷',n:'Greece',d:'+30'},{f:'🇷🇴',n:'Romania',d:'+40'},{f:'🇭🇷',n:'Croatia',d:'+385'},
    {f:'🇱🇺',n:'Luxembourg',d:'+352'},{f:'🇺🇸',n:'United States',d:'+1'},{f:'🇨🇦',n:'Canada',d:'+1'},
    {f:'🇲🇽',n:'Mexico',d:'+52'},{f:'🇧🇷',n:'Brazil',d:'+55'},{f:'🇦🇷',n:'Argentina',d:'+54'},
    {f:'🇦🇪',n:'UAE',d:'+971'},{f:'🇸🇦',n:'Saudi Arabia',d:'+966'},{f:'🇶🇦',n:'Qatar',d:'+974'},
    {f:'🇦🇺',n:'Australia',d:'+61'},{f:'🇿🇦',n:'South Africa',d:'+27'}
  ];
  var wrap = document.getElementById('ccSelect');
  if(!wrap) return;
  var trigger = document.getElementById('ccTrigger');
  var panel   = document.getElementById('ccPanel');
  var hidden  = document.getElementById('f_code');
  var flagEl  = document.getElementById('ccFlag');
  var codeEl  = document.getElementById('ccCode');

  function select(c){
    hidden.value = c.d;
    flagEl.textContent = c.f;
    codeEl.textContent = c.d;
    Array.prototype.forEach.call(panel.children, function(b){
      b.classList.toggle('sel', b.getAttribute('data-d')===c.d && b.getAttribute('data-n')===c.n);
    });
  }
  COUNTRIES.forEach(function(c){
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'cc-opt';
    b.setAttribute('role','option');
    b.setAttribute('data-d', c.d);
    b.setAttribute('data-n', c.n);
    b.innerHTML = '<span class="cc-oflag">'+c.f+'</span><span class="cc-name">'+c.n+'</span><span class="cc-dial">'+c.d+'</span>';
    b.addEventListener('click', function(){ select(c); close(); });
    panel.appendChild(b);
  });
  select(COUNTRIES[0]);

  function open(){ wrap.classList.add('open'); trigger.setAttribute('aria-expanded','true'); }
  function close(){ wrap.classList.remove('open'); trigger.setAttribute('aria-expanded','false'); }
  trigger.addEventListener('click', function(e){
    e.stopPropagation();
    wrap.classList.contains('open') ? close() : open();
  });
  document.addEventListener('click', function(e){ if(!wrap.contains(e.target)) close(); });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') close(); });
})();

/* ===== next block ===== */

/* Clubs & Retailers photo carousel: auto-advances and supports the right arrow */
(function(){
  var slider=document.querySelector('[data-stock-slider]');
  if(!slider) return;
  var slides=Array.prototype.slice.call(slider.querySelectorAll('.stock-slide'));
  if(slides.length<2) return;
  var idx=0, timer=null, DELAY=4500;

  // build dot indicators
  var dots=document.createElement('div');
  dots.className='stock-dots';
  var dotBtns=slides.map(function(_,i){
    var b=document.createElement('button');
    b.type='button';
    b.setAttribute('aria-label','Show photo '+(i+1));
    b.addEventListener('click',function(){ go(i); restart(); });
    dots.appendChild(b);
    return b;
  });
  slider.appendChild(dots);

  function go(n){
    idx=(n+slides.length)%slides.length;
    slides.forEach(function(s,i){ s.classList.toggle('is-active', i===idx); });
    dotBtns.forEach(function(d,i){ d.classList.toggle('is-active', i===idx); });
  }
  function next(){ go(idx+1); }
  function start(){ timer=setInterval(next, DELAY); }
  function stop(){ if(timer){ clearInterval(timer); timer=null; } }
  function restart(){ stop(); start(); }

  var nav=slider.querySelector('.stock-nav');
  if(nav) nav.addEventListener('click', function(){ next(); restart(); });

  // pause on hover so a reader isn't rushed
  slider.addEventListener('mouseenter', stop);
  slider.addEventListener('mouseleave', start);

  go(0);
  start();
})();

/* ===== next block ===== */

/* ============ REVIEWS ============
   Bezoekers schrijven een review (sterren + korte tekst). Bij verzenden
   komt die bij JOU binnen via Shopify (Instellingen > Meldingen > contactformulier-mail), net als je
   pre-order/enquiry. Niets wordt automatisch op de site gezet.

   --> WIL JE EEN REVIEW TONEN? <--
   Kopieer de tekst uit de Shopify-mail en zet 'm in de lijst
   APPROVED_REVIEWS hieronder. Voeg een regel toe, sla op, deploy. Klaar.
   rating = 1 t/m 5.  role = optioneel (bv. "Golfer · Madrid").
*/
(function(){
  "use strict";

  var APPROVED_REVIEWS = [
    // { name:"Marco V.", role:"Golfer \u00b7 Madrid", rating:5, text:"Geweldig na een lange ronde." },
    // { name:"Lisa K.",  role:"",                          rating:5, text:"Fijne stick, trekt snel in." },
  ];

  var grid    = document.getElementById('testGrid');
  var toggle  = document.getElementById('revToggle');
  var panel   = document.getElementById('revPanel');
  var starBox = document.getElementById('revStars');
  var nameEl  = document.getElementById('revName');
  var textEl  = document.getElementById('revText');
  var countEl = document.getElementById('revCount');
  var sendEl  = document.getElementById('revSubmit');
  var msgEl   = document.getElementById('revMsg');
  if(!grid || !toggle || !panel || !starBox) return;

  var MAX = 200;
  var rating = 0;

  var STR = {
    en:{namePh:'Your name', textPh:'A short review \u2014 what did you think?',
        eRate:'Please pick a star rating.', eName:'Please add your name.',
        eText:'Please write a short review.',
        thanks:'Thanks! Your review has been sent for approval.',
        eSend:'Could not send \u2014 please try again or email info@golfcarestick.com.'},
    es:{namePh:'Tu nombre', textPh:'Una breve rese\u00f1a: \u00bfqu\u00e9 te pareci\u00f3?',
        eRate:'Elige una puntuaci\u00f3n con estrellas.', eName:'A\u00f1ade tu nombre.',
        eText:'Escribe una breve rese\u00f1a.',
        thanks:'\u00a1Gracias! Tu rese\u00f1a se ha enviado para su aprobaci\u00f3n.',
        eSend:'No se pudo enviar \u2014 int\u00e9ntalo de nuevo o escribe a info@golfcarestick.com.'},
    nl:{namePh:'Je naam', textPh:'Een korte review \u2014 wat vond je ervan?',
        eRate:'Kies een sterrenscore.', eName:'Vul je naam in.',
        eText:'Schrijf een korte review.',
        thanks:'Bedankt! Je review is verstuurd \u2014 we plaatsen \u2019m binnenkort.',
        eSend:'Verzenden mislukt \u2014 probeer opnieuw of mail info@golfcarestick.com.'}
  };
  function L(){ return STR[window.currentLang] || STR.en; }
  function applyLang(){ var s=L(); if(nameEl) nameEl.placeholder=s.namePh; if(textEl) textEl.placeholder=s.textPh; }
  applyLang();
  document.querySelectorAll('.lang-btn').forEach(function(b){
    b.addEventListener('click', function(){ setTimeout(applyLang, 0); });
  });

  function initials(name){
    var p = String(name).trim().split(/\s+/).filter(Boolean);
    var s = (p[0]?p[0][0]:'') + (p[1]?p[1][0]:'');
    return (s || (String(name).trim()[0]||'?')).toUpperCase();
  }
  function starsHTML(r){
    var out=''; r=Math.max(1,Math.min(5,parseInt(r,10)||5));
    for(var i=1;i<=5;i++){ out += '<span class="'+(i<=r?'s-on':'s-off')+'">\u2605</span>'; } return out;
  }
  function makeCard(rev){
    var el = document.createElement('div');
    el.className = 'test-card is-user';
    el.innerHTML = '<div class="stars">'+starsHTML(rev.rating)+'</div>'
      + '<p class="quote"></p>'
      + '<div class="who"><div class="av"></div><div><b></b><span></span></div></div>';
    el.querySelector('.quote').textContent = '\u201c' + (rev.text||'') + '\u201d';
    el.querySelector('.av').textContent = initials(rev.name);
    el.querySelector('.who b').textContent = rev.name || '';
    el.querySelector('.who span').textContent = rev.role || '';
    return el;
  }

  /* show the reviews YOU approved, ahead of the built-in testimonials */
  var seedFirst = grid.firstChild;
  var frag = document.createDocumentFragment();
  APPROVED_REVIEWS.forEach(function(r){ if(r && r.name && r.text) frag.appendChild(makeCard(r)); });
  grid.insertBefore(frag, seedFirst);

  /* star picker */
  var starBtns = Array.prototype.slice.call(starBox.querySelectorAll('button'));
  function paint(n){ starBtns.forEach(function(b,i){ b.classList.toggle('on', i < n); }); }
  starBtns.forEach(function(b){
    var v = parseInt(b.getAttribute('data-v'), 10);
    b.addEventListener('mouseenter', function(){ paint(v); });
    b.addEventListener('click', function(){ rating = v; paint(v); msgEl.textContent=''; msgEl.classList.remove('err'); });
  });
  starBox.addEventListener('mouseleave', function(){ paint(rating); });

  /* char counter */
  if(textEl && countEl){
    textEl.addEventListener('input', function(){ countEl.textContent = String(textEl.value.length); });
  }

  /* toggle */
  toggle.addEventListener('click', function(){
    var open = panel.classList.toggle('open');
    if(open) setTimeout(function(){ nameEl && nameEl.focus(); }, 320);
  });

  /* submit -> Shopify contact form (lands in your store email) */
  function flashErr(el){ if(!el) return; el.classList.add('err'); setTimeout(function(){ el.classList.remove('err'); }, 1600); }
  sendEl.addEventListener('click', function(){
    var s = L();
    var name = (nameEl.value||'').trim();
    var text = (textEl.value||'').trim().slice(0,MAX);
    msgEl.classList.remove('err');
    if(!rating){ msgEl.textContent = s.eRate; msgEl.classList.add('err'); flashErr(starBox); return; }
    if(!name){ msgEl.textContent = s.eName; msgEl.classList.add('err'); flashErr(nameEl); return; }
    if(text.length < 3){ msgEl.textContent = s.eText; msgEl.classList.add('err'); flashErr(textEl); return; }

    sendEl.disabled = true;
    window.pcsSubmit('review', 'New GOLF CARE review \u2014 ' + rating + '\u2605 by ' + name, {
      name: name, rating: String(rating), review: text, lang: (window.currentLang || 'en')
    });
  });

  window.__pcsReviewDone = function(){
    var s = L();
    msgEl.classList.remove('err'); msgEl.textContent = s.thanks;
    rating = 0; paint(0); nameEl.value=''; textEl.value=''; if(countEl) countEl.textContent='0';
    sendEl.disabled = false;
    panel.classList.add('open');
    setTimeout(function(){ panel.classList.remove('open'); }, 2200);
    setTimeout(function(){ msgEl.textContent=''; }, 6000);
    var r = document.getElementById('reviews'); if(r) r.scrollIntoView();
  };
})();

/* ===== next block ===== */

(function(){function close(d){d.classList.remove('open');var t=d.querySelector('.bd-trigger');if(t)t.setAttribute('aria-expanded','false');}document.querySelectorAll('.brand-drop .bd-trigger').forEach(function(t){t.addEventListener('click',function(e){e.stopPropagation();var d=t.closest('.brand-drop');var o=d.classList.toggle('open');t.setAttribute('aria-expanded',o?'true':'false');document.querySelectorAll('.brand-drop.open').forEach(function(x){if(x!==d)close(x);});});});document.addEventListener('click',function(){document.querySelectorAll('.brand-drop.open').forEach(close);});})();

/* ===== next block ===== */

/* ===== Shopify contact-form bridge (replaces Netlify Forms) ===== */
window.pcsSubmit = function(kind, subject, fields){
  var f = document.getElementById('pcsProxyForm');
  if(!f){ alert('Form unavailable. Please email info@golfcarestick.com'); return; }
  document.getElementById('pcsF_name').value  = fields.name  || 'Website visitor';
  document.getElementById('pcsF_email').value = fields.email || 'info@golfcarestick.com';
  var lines = [subject, ''];
  Object.keys(fields).forEach(function(k){ if(fields[k]) lines.push(k + ': ' + fields[k]); });
  lines.push('', 'Sent via ' + kind + ' form on ' + location.hostname);
  document.getElementById('pcsF_body').value = lines.join('\n');
  try{ sessionStorage.setItem('pcs_posted', kind); }catch(e){}
  f.submit();
};

/* Restore the right success state after Shopify redirects back */
(function(){
  if(!window.PCS_POSTED) return;
  var kind = null;
  try{ kind = sessionStorage.getItem('pcs_posted'); sessionStorage.removeItem('pcs_posted'); }catch(e){}
  if(!kind) return;
  if(kind === 'preorder'){
    var f = document.getElementById('preorderForm'), d = document.getElementById('poDone');
    if(f && d){ f.setAttribute('hidden',''); d.removeAttribute('hidden'); }
    var s = document.getElementById('shop'); if(s) s.scrollIntoView();
  } else if(kind === 'enquiry' && window.__pcsEnquiryDone){
    window.__pcsEnquiryDone();
  } else if(kind === 'review' && window.__pcsReviewDone){
    window.__pcsReviewDone();
  }
})();

/* ===== Buy card: quantity stepper + WhatsApp fallback ===== */
(function(){
  var card = document.getElementById('buyCard');
  if(!card) return;
  var input = card.querySelector('.qty-in');
  var wa = document.getElementById('buyWa');
  var BRAND = 'GOLF CARE';
  var WA_MSG = {
    en:function(q){ return 'Hi '+BRAND+'! I\'d like to buy '+q+' '+BRAND+' Stick'+(q>1?'s':'')+'.'; },
    es:function(q){ return '\u00a1Hola '+BRAND+'! Quiero comprar '+q+' '+BRAND+' Stick'+(q>1?'s':'')+'.'; },
    nl:function(q){ return 'Hoi '+BRAND+'! Ik wil graag '+q+' '+BRAND+' Stick'+(q>1?'s':'')+' kopen.'; }
  };
  function clamp(v){ v = parseInt(v,10); if(!v||v<1) v=1; if(v>20) v=20; return v; }
  function sync(){
    if(!input) return;
    input.value = clamp(input.value);
    if(wa){
      var fn = WA_MSG[window.currentLang] || WA_MSG.en;
      wa.href = 'https://wa.me/34682123662?text='+encodeURIComponent(fn(clamp(input.value)));
    }
  }
  card.querySelectorAll('.qty-btn').forEach(function(b){
    b.addEventListener('click', function(){ input.value = clamp((parseInt(input.value,10)||1) + parseInt(b.getAttribute('data-qty'),10)); sync(); });
  });
  if(input) input.addEventListener('change', sync);
  document.addEventListener('click', function(e){ if(e.target.closest && e.target.closest('[data-lang]')) setTimeout(sync,0); });
  sync();
})();
